import React from 'react';
import { Flex } from 'antd';
import KnowledgeBaseSkeletonItem from './KnowledgeBaseSkeletonItem';

const KnowledgeBaseSkeleton = () => {
    return (
        <Flex gap={16} wrap justify="center" style={{ flexGrow: 1 }}>
            {[...Array(3)].map((_, index) => (
                <KnowledgeBaseSkeletonItem key={index} />
            ))}
        </Flex>
    );
};

export default KnowledgeBaseSkeleton; 